<template>
    <v-form @submit.prevent="onSubmit($event)" autocomplete="off">
        <v-card class="elevation-12">
            <v-toolbar flat tabs color="grey lighten-3">
                <v-toolbar-side-icon @click="exit">
                    <v-icon color="primary">close</v-icon>
                </v-toolbar-side-icon>
                <template v-if="product">
                    <v-toolbar-title>Editar Produto</v-toolbar-title>
                    <v-spacer></v-spacer>
                </template>
                <template v-else>
                    <v-toolbar-title>Novo Produto</v-toolbar-title>
                    <v-spacer></v-spacer>
                </template>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon flat large v-on="on" @click="productForm.highlight = !productForm.highlight">
                            <v-icon large :color="(productForm.highlight) ? 'primary' : 'grey'">
                                star
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>Marque para mostrar o produto em destaque</span>
                </v-tooltip>
                <div>
                    <v-switch v-model="productForm.active" label="ativo" hide-details color="primary">
                        <template v-slot:append>
                            <sp-tooltip tip="Desmarque para ocultar produtos para venda. (Ex: Produto sem estoque)">
                            </sp-tooltip>
                        </template>
                    </v-switch>
                </div>
                <template v-slot:extension>
                    <v-tabs v-model="productTab" fixed-tabs color="grey lighten-3" slider-color="secondary">
                        <v-tab ripple href="#basic">
                            <span class="pr-2">Básico</span>
                            <sp-tooltip
                                tip='Comece criando seus produtos com o "Básico" e </br> havendo necessidade use o "Avançado" para ajustes.'>
                            </sp-tooltip>
                        </v-tab>
                        <v-tab ripple href="#advanced">
                            <span class="pr-2">Avançado</span>
                            <sp-tooltip
                                tip='Use o "Avançado" para ocultar produtos na </br> lista de produtos e demais configurações.'>
                            </sp-tooltip>
                        </v-tab>
                    </v-tabs>
                </template>
            </v-toolbar>
            <v-card-text class="pa-0" id="productForm">
                <v-tabs-items v-model="productTab">
                    <v-tab-item value="basic">
                        <v-card-text class="pt-0">
                            <v-container grid-list-md pa-0 fluid>
                                <v-layout row wrap fill-height>
                                    <v-flex xs12 sm8>
                                        <v-layout row wrap justify-space-between>
                                            <v-flex xs12>
                                                <v-text-field label="Nome" type="text" outline
                                                    v-model="productForm.productname" required clearable autofocus
                                                    v-if="productDialog" id="productname" v-validate="'required'"
                                                    data-vv-name="productname"
                                                    :error-messages="errors.collect('productname')"></v-text-field>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-textarea label="Descrição" type="text" outline
                                                    v-model="productForm.description" required clearable rows="2"
                                                    :disabled="productForm.unit == 'G'"></v-textarea>
                                            </v-flex>
                                            <v-flex x12 md6>
                                                <v-autocomplete v-model="productForm.type_id"
                                                    label="Categoria do Produto" required
                                                    :items="menu.filter(v => !v.highlight)" item-value="_id"
                                                    item-text="name" outline
                                                    no-data-text="Clique no + para criar nova categoria"
                                                    :filter="filter" prepend-inner-icon="add"
                                                    @click:prepend-inner="createType" @change="getSubtypes"
                                                    id="category" v-validate="'required'" data-vv-name="type_id"
                                                    :error-messages="errors.collect('type_id')">
                                                    <template v-slot:append-outer>
                                                        <sp-tooltip
                                                            tip="Crie ou escolha uma categoria ou Subcategoria </br> de produtos para facilitar na busca. Ex: </br> Categoria: Bebidas </br> Subcategoria: Refrigerantes, Suco, Cervejas">
                                                        </sp-tooltip>
                                                    </template>
                                                </v-autocomplete>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <v-autocomplete v-model="productForm.subtype_id"
                                                    label="Subcategoria do Produto" required :items="subtypes"
                                                    item-value="_id" item-text="name" outline :filter="filter"
                                                    :loading="stLoading"
                                                    no-data-text="Clique no + para criar Subcategoria"
                                                    prepend-inner-icon="add" @click:prepend-inner="editType">
                                                    <template v-slot:append-outer>
                                                        <sp-tooltip
                                                            tip="Crie ou escolha uma categoria ou Subcategoria </br> de produtos para facilitar na busca. Ex: </br> Categoria: Bebidas </br> Subcategoria: Refrigerantes, Suco, Cervejas">
                                                        </sp-tooltip>
                                                    </template>
                                                </v-autocomplete>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-autocomplete v-model="productForm.combolist_id" label="Complementos"
                                                    required :items="comboesAnchored" item-value="_id" item-text="description"
                                                    outline no-data-text="Clique em + para novo complemento"
                                                    :filter="filter" prepend-inner-icon="add"
                                                    @click:prepend-inner="newCombo" @click="scrollMenu"  
                                                    :loading="loading" clearable>
                                                    <template v-slot:item="{ tile, item }">
                                                        <v-list-tile class="combo-item" v-bind="tile.props" v-on="tile.on"
                                                            active-class="primary--text">
                                                            <v-list-tile-content>
                                                                <v-list-tile-title
                                                                    v-html="item.description"></v-list-tile-title>
                                                            </v-list-tile-content>
                                                            <v-list-tile-action @click="editCombo(item._id)">
                                                                <v-icon color="accent">edit</v-icon>
                                                            </v-list-tile-action>
                                                            <v-list-tile-action
                                                                @click="deleteConfirm({ combo: true, id: item._id })">
                                                                <v-icon color="red">delete</v-icon>
                                                            </v-list-tile-action>
                                                        </v-list-tile>
                                                    </template>
                                                    <template v-slot:append-outer>
                                                        <sp-tooltip
                                                            tip="Escolha complementos e adicionais para o produto. </br> (Ex: Escolha seu pão, Escolha seu recheio, Escolha até 3 molhos)">
                                                        </sp-tooltip>
                                                    </template>
                                                </v-autocomplete>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-layout justify-center wrap>
                                                    <v-flex xs6 sm3>
                                                        <v-text-field label="Código" type="number" outline
                                                            v-model="productForm.code" required></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs6 sm3 v-show="productForm.discount">
                                                        <v-text-field label="Preço Original" type="text"
                                                            v-money="config" v-model.lazy="productForm.regular_price"
                                                            ref="regular_price" prefix="R$"
                                                            :hint="(productForm.unit == 'G') ? 'Total: ' + totalRegularPrice : ''"
                                                            :persistent-hint="productForm.unit == 'G'" required outline
                                                            id="regular_price" v-validate="'required'"
                                                            data-vv-name="regular_price"
                                                            :error-messages="errors.collect('regular_price')"></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs6 sm3 v-if="productForm.unit == 'G'">
                                                        <v-text-field label="Preço por kg" type="text" v-money="config"
                                                            v-model.lazy="productForm.original_price"
                                                            :hint="'Total: ' + totalPrice" persistent-hint ref="price"
                                                            prefix="R$" required outline id="original_price"
                                                            v-validate="'required'" data-vv-name="original_price"
                                                            :error-messages="errors.collect('original_price')"></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs6 sm3 v-else>
                                                        <v-text-field
                                                            :label="productForm.discount ? 'Preço Promoção' : 'Preço'"
                                                            type="text" v-money="config"
                                                            v-model.lazy="productForm.price" ref="price" prefix="R$"
                                                            required outline id="price" v-validate="'required'"
                                                            data-vv-name="price"
                                                            :error-messages="errors.collect('price')"
                                                            :disabled="productForm.unit == 'G'"></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs6 sm3>
                                                        <v-switch color="primary" v-model="productForm.discount"
                                                            label="Desconto"></v-switch>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <v-layout pt-2 row v-if="productForm.bar_code != ''" align-center
                                            justify-center>
                                            <v-flex class="text-xs-center">
                                                <span class="body-2">Cód. Barras: {{ productForm.bar_code }}
                                                    <input type="hidden" id="bar-code" :value="productForm.bar_code">
                                                    <v-tooltip bottom activator="#clipboard" v-model="clipboard">
                                                        <span>Copiado</span>
                                                    </v-tooltip>
                                                    <v-btn icon small flat color="grey" id="clipboard"
                                                        @click="clipboardAction(productForm.bar_code)">
                                                        <v-icon>assignment</v-icon>
                                                    </v-btn>
                                                </span>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row justify-center pl-2 fill-height>
                                            <v-flex xs7 sm12 v-if="productForm.photo">
                                                <v-img
                                                    :src="((productForm.photo.startsWith('data')) ? '' : uri) + productForm.photo"
                                                    width="100%" class="grey lighten-2" aspect-ratio="1" contain>
                                                    <v-container fill-height fluid pa-0>
                                                        <v-layout row wrap justify-center align-center>
                                                            <v-btn class="sp-transparent-red" dark
                                                                @click="productForm.photo = ''">
                                                                Remover
                                                            </v-btn>
                                                        </v-layout>
                                                    </v-container>
                                                </v-img>
                                                <span class="body-1 grey--text lighten-1">Imagem quadrada. Formato JPEG
                                                    ou JPG. Máx:
                                                    500KB</span>
                                            </v-flex>
                                            <v-flex xs12 v-else>
                                                <image-selector hide-preview hide-after-crop v-model="productForm.photo"
                                                    @start="cropping = true" @end="cropping = false"
                                                    v-if="productDialog">
                                                    <template #cropperActions="{ handles }">
                                                        <v-layout justify-center>
                                                            <v-btn icon flat @click="handles.handleCropButtonClick"
                                                                color="success" large ref="cropImage">
                                                                <v-icon>check</v-icon>
                                                            </v-btn>
                                                            <v-btn icon flat @click="handles.handleResetButtonClick"
                                                                color="warning" large>
                                                                <v-icon>undo</v-icon>
                                                            </v-btn>
                                                            <v-btn icon flat @click="handles.handleCancelButtonClick"
                                                                color="error" large>
                                                                <v-icon>block</v-icon>
                                                            </v-btn>
                                                        </v-layout>
                                                    </template>
                                                    <template #uploaderActions="{ handles }">
                                                        <v-img width="100%" class="grey lighten-2" aspect-ratio="1"
                                                            contain>
                                                            <v-container fill-height fluid pa-0>
                                                                <v-layout row wrap justify-center align-center>
                                                                    <v-flex xs12 class="subheading text-xs-center">
                                                                        <span>Cole a sua imagem</span>
                                                                    </v-flex>
                                                                    <v-btn @click="handles.handleSelecionarButtonClick">
                                                                        anexar
                                                                        <v-icon right>attach_file</v-icon>
                                                                    </v-btn>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-img>
                                                    </template>
                                                </image-selector>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <div id="errorBasic">
                                <span class="error--text">{{ error }}</span>
                            </div>
                        </v-card-text>
                    </v-tab-item>
                    <v-tab-item value="advanced">
                        <v-card-text>
                            <v-container grid-list-md pa-0 fluid>
                                <v-layout row wrap justify-space-around>
                                    <v-flex xs12>
                                        <v-text-field label="Nome de exibição" type="text" outline
                                            v-model="productForm.productname_display" clearable id="productname_display"
                                            :disabled="productForm.unit == 'G'"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea label="Detalhes" type="text" outline v-model="productForm.details"
                                            required clearable counter rows="2"></v-textarea>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-combobox v-model="productForm.keywords" :items="productForm.keywords"
                                            :search-input.sync="search" :hide-no-data="!search" hide-selected
                                            label="Palavras-chave" multiple outline chips>
                                            <template v-slot:no-data>
                                                <v-list-tile>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>
                                                            Pressione <kbd>enter</kbd> para criar uma nova
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </template>
                                        </v-combobox>
                                    </v-flex>
                                    <v-flex xs6 md3>
                                        <v-text-field label="Código de barras" type="text" outline
                                            v-model="productForm.bar_code" required></v-text-field>
                                    </v-flex>
                                    <v-flex xs6 md2>
                                        <v-select v-model="productForm.unit"
                                            :items="[{ text: 'Unidade', value: 'UN' }, { text: 'Gramas', value: 'G' }]"
                                            label="Unidade" outline></v-select>
                                    </v-flex>
                                    <v-fade-transition>
                                        <v-flex xs6 md2 v-if="productForm.unit == 'G'">
                                            <v-text-field label="Peso" type="text" outline
                                                v-model="productForm.product_yield" required>
                                                <template v-slot:append>
                                                    <sp-tooltip tip="Informe o peso do produto para venda">
                                                    </sp-tooltip>
                                                </template>
                                            </v-text-field>
                                        </v-flex>
                                    </v-fade-transition>
                                    <v-flex xs6 md2>
                                        <v-text-field label="Múltiplo" type="text" outline
                                            v-model="productForm.multiple" required>
                                            <template v-slot:append>
                                                <sp-tooltip tip="Marque para controlar estoque do produto">
                                                </sp-tooltip>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs6 md3>
                                        <v-text-field label="Quant. Máx. por pedido" type="number" outline
                                            v-model="productForm.max_quantity" required hint="0 para sem limites"
                                            persistent-hint></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap justify-space-between>
                                    <v-flex xs6>
                                        <v-switch label="Usar estoque" color="primary" v-model="stockFields" required
                                            @change="ChangeStockSwitch">
                                            <template v-slot:append>
                                                <sp-tooltip tip="Marque para controlar estoque do produto">
                                                </sp-tooltip>
                                            </template>
                                        </v-switch>
                                    </v-flex>
                                    <v-flex xs6 v-if="stockFields">
                                        <v-switch label="Vender s/ estoque" color="primary"
                                            v-model="productForm.sale_without_stock" hide-details>
                                        </v-switch>
                                    </v-flex>
                                    <template v-if="stockFields">
                                        <v-flex xs6>
                                            <v-text-field label="Estoque" type="number" outline
                                                v-model="productForm.stock"></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field label="Margem de Segurança" type="number" outline
                                                v-model="productForm.safety_margin"></v-text-field>
                                        </v-flex>
                                    </template>
                                </v-layout>
                                <v-layout row wrap justify-space-between>
                                    <v-flex xs12>
                                        <v-switch label="Adicionar Custos e Impostos" color="primary" v-model="CTFields"
                                            required @change="ChangeCTSwitch">
                                            <template v-slot:append>
                                                <sp-tooltip tip="Marque para adicionar custos e impostos">
                                                </sp-tooltip>
                                            </template>
                                        </v-switch>
                                    </v-flex>
                                    <template v-if="CTFields">
                                        <v-flex xs3>
                                            <v-text-field label="Custos" type="text" outline v-money="config"
                                                v-model.lazy="productForm.costs" ref="costs" prefix="R$"></v-text-field>
                                        </v-flex>
                                        <v-flex xs3>
                                            <v-text-field label="Impostos (%)" type="number" outline
                                                v-model="productForm.taxes"></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-autocomplete label="Prestador responsável" :items="serviceSuppliers"
                                                outline :loading="loadingSS" autocomplete="off" item-text="name"
                                                item-value="service_supplier_id" clearable
                                                v-model="productForm.costs_recipient_restaurant_id"></v-autocomplete>
                                        </v-flex>
                                    </template>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 xl4>
                                        <v-switch label="Ocultar produto" color="primary"
                                            v-model="productForm.hide_on_app" required>
                                            <template v-slot:append>
                                                <sp-tooltip
                                                    tip="Marque para ocultar na lista de produtos para os clientes. (Não influencia em complementos)">
                                                </sp-tooltip>
                                            </template>
                                        </v-switch>
                                    </v-flex>
                                    <v-flex xs12 sm6 xl4>
                                        <v-switch label="Somente primeira compra" color="primary"
                                            v-model="productForm.first_purchase_only" required>
                                            <template v-slot:append>
                                                <sp-tooltip
                                                    tip="Marque para mostrar o produto apenas para novos clientes">
                                                </sp-tooltip>
                                            </template>
                                        </v-switch>
                                    </v-flex>
                                    <v-flex xs12 sm6 xl4>
                                        <v-switch label="Produto promocional" color="primary" outline
                                            v-model="productForm.promotional_product" required>
                                            <template v-slot:append>
                                                <sp-tooltip
                                                    tip="Marque para desativar o uso de cupons de desconto nesse produto">
                                                </sp-tooltip>
                                            </template>
                                        </v-switch>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 xl4>
                                        <v-switch label="Produto pendente" color="primary" outline
                                            v-model="productForm.pending_print" required>
                                            <template v-slot:append>
                                                <sp-tooltip
                                                    tip="Marque para a impressão do produto só ocorrer quando solicitado pelo cliente">
                                                </sp-tooltip>
                                            </template>
                                        </v-switch>
                                    </v-flex>
                                    <v-flex xs12 sm6 xl4>
                                        <v-switch label="Produto de Gerente" color="primary" outline
                                            v-model="productForm.manager_only" required>
                                            <template v-slot:append>
                                                <sp-tooltip tip="Marque para o produto ser exibido apenas para gerente">
                                                </sp-tooltip>
                                            </template>
                                        </v-switch>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 xl4>
                                        <v-switch label="Produto de Check-in" color="primary" outline
                                            v-model="productForm.check_in_product" required>
                                            <template v-slot:append>
                                                <sp-tooltip tip="Marque para o produto ser na tela de check-in">
                                                </sp-tooltip>
                                            </template>
                                        </v-switch>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <span v-if="error" id="errorAdvanced" class="error--text">{{ error }}</span>
                        </v-card-text>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
            <v-card-actions class="layout row justify-center">
                <v-btn color="success" large type="submit" class="mb-3" :loading="loading" :disabled="loading">
                    Salvar Produto
                </v-btn>
            </v-card-actions>
            <v-dialog v-model="comboDialog" lazy max-width="600px" scrollable persistent
                :fullscreen="$vuetify.breakpoint.xsOnly">
                <v-card class="elevation-12">
                    <v-toolbar flat tabs color="grey lighten-3">
                        <v-toolbar-side-icon @click="newSession = editComboName = comboDialog = false">
                            <v-icon color="primary">close</v-icon>
                        </v-toolbar-side-icon>
                        <template v-if="!editComboName">
                            <v-toolbar-title>
                                {{ combo.description }}
                            </v-toolbar-title>
                            <v-btn icon small @click="editComboName = true">
                                <v-icon color='accent'>edit</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                        </template>
                        <v-layout v-else pt-2 pr-3>
                            <v-flex>
                                <v-text-field label="Nome do combo" autofocus v-if="comboDialog"
                                    placeholder="Ex: Monte seu lanche" append-icon="done" v-model="combo.description"
                                    @click:append="saveCombo" :error-messages="comboErrors" @keyup.enter="saveCombo">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <div v-if="combo._id">
                            <v-btn icon color="success" @click="newSession = true">
                                <v-icon>add</v-icon>
                            </v-btn>
                        </div>
                        <template v-slot:extension v-if="editComboName && combo._id">
                            <v-layout row justify-center>
                                <v-flex xs12 sm8>
                                    <v-switch v-model="combo.combo_default_value"
                                        label="Valor do produto deve ser somente a soma dos complementos">
                                        <template v-slot:append>
                                            <sp-tooltip
                                                tip="Essa opção considera apenas </br> a soma dos complementos, </br> ignorando o valor do produto.">
                                            </sp-tooltip>
                                        </template>
                                    </v-switch>
                                </v-flex>
                            </v-layout>
                        </template>
                    </v-toolbar>
                    <v-card-text style="height: 5000px;" :id="'combo' + combo._id">
                        <draggable tag="v-expansion-panel" :list="combo.combosession_list" class="draggable"
                            :component-data="getComboSessionData()" @change="reorderSessions" draggable=".item"
                            :handle="$vuetify.breakpoint.smAndDown ? '.handle' : ''">
                            <template slot="header">
                                <sp-combo-session :comboId="combo._id" @delete="deleteSession" v-if="newSession"
                                    :togglePanel="newSession" @newSession="addingSession"></sp-combo-session>
                            </template>
                            <sp-combo-session v-for="id in combo.combosession_list"
                                :session="combo.combosession_list_data[id]" :comboId="combo._id" :key="id"
                                @delete="deleteConfirm" :draggable="!newSession" @refresh="refreshCombo(combo._id)">
                            </sp-combo-session>
                        </draggable>
                    </v-card-text>
                    <v-card-actions>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="deleteDialog" lazy max-width="250px">
                <v-card>
                    <v-card-text class="headline text-xs-center">
                        Tem certeza que deseja excluir?
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn color="black" flat @click="deleteDialog = false" :disabled="loading">
                            Não
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="red" flat @click="delData.func(delData.id)" :loading="loading"
                            :disabled="loading">
                            Sim
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
        <v-snackbar v-model="snackbar" :timeout="5000" bottom>
            {{ snackbarText }}
            <v-btn color="pink" flat @click="snackbar = false">
                Close
            </v-btn>
        </v-snackbar>
    </v-form>
</template>

<script>
import { mapGetters } from 'vuex'
import SpComboSession from './SpComboSession'
import draggable from 'vuedraggable'
import ImageSelector from '@/components/cropper/ImageSelector'

export default {
    $_veeValidate: {
        validator: 'new'
    },
    components: {
        SpComboSession,
        draggable,
        ImageSelector
    },
    data() {
        return {
            error: null,
            config: { decimal: ',', thousands: '.', prefix: '', suffix: '', precision: 2 },
            productForm: {
                productname: '',
                productname_display: '',
                price: '0,00',
                original_price: '0,00',
                regular_price: '0,00',
                discount: false,
                photo: '',
                description: '',
                details: '',
                code: '',
                bar_code: '',
                type_id: '',
                subtype_id: '',
                combolist_id: '',
                multiple: 1,
                unit: "UN",
                max_quantity: 0,
                safety_margin: 0,
                first_purchase_only: false,
                promotional_product: false,
                product_yield: 1000,
                hide_on_app: false,
                stock: 0,
                sale_without_stock: true,
                active: true,
                highlight: false,
                pending_print: false,
                manager_only: false,
                check_in_product: false,
                keywords: [],
                costs: '0,00',
                taxes: 0,
                costs_recipient_restaurant_id: null
            },
            serviceSuppliers: [],
            loadingSS: false,
            mode: false,
            subtypes: [{ _id: '', name: 'Nenhum' }],
            loading: false,
            stLoading: false,
            productTab: "basic",
            snackbar: false,
            snackbarText: "",
            stockFields: false,
            CTFields: false,
            comboDialog: false,
            comboErrors: [],
            editComboName: false,
            combo: {
                description: "",
                selected_products: [],
                type_id: [],
                combosession_list: [],
                combo_default_value: false,
                combosession_list_data: {},
                enabled: true
            },
            comboes: [],
            newSession: false,
            deleteDialog: false,
            delData: { func: null, id: "" },
            search: '',
            clipboard: false,
            uri: 'https://api.socialplace.com.br'
        }
    },
    computed: {
        ...mapGetters([
            'util',
            'restaurant',
            'menu',
            'typeSelected',
            'product',
            'products',
            'productDialog',
            'typeDialog'
        ]),
        totalRegularPrice() {
            const { regular_price, product_yield } = this.productForm
            return this.price(parseFloat(regular_price.toString().replace(',', '.')) / 1000 * product_yield)
        },
        totalPrice() {
            const { original_price, product_yield } = this.productForm
            return this.price(parseFloat(original_price.toString().replace(',', '.')) / 1000 * product_yield)
        },
        comboesAnchored() {
            return [...this.comboes].sort((a) => {
                    if (a._id === this.productForm.combolist_id) {
                    return -1
                }
                return 0
            })
        }
    },

    watch: {
        'productForm.costs_recipient_restaurant_id'(val) {
            if (val == null) {
                this.productForm.costs_recipient_restaurant_id = ''
            }
        },
        CTFields(val) {
            if (val) {
                this.getServiceSuppliers()
            }
        },
        typeSelected(v) {
            if (v) {
                this.productForm.type_id = v.type_id
                this.getSubtypes()
            }
        },
        productDialog(v) {
            if (v) {
                this.setForm()
            }
        },
        menu(v) {
            const i = v.map(el => el.enabled).lastIndexOf(true)
            this.productForm.type_id = v[i]._id
        },
        async products() {
            if (!this.product) {
                this.productForm.code = await this.$store.dispatch('generateCode')
            }
        },
        typeDialog(v) {
            if (!v)
                this.getSubtypes()
        },
        error(v) {
            if (v) {
                const tagError = "#error" + ((this.productTab == 'basic') ? 'Basic' : 'Advanced')
                this.$vuetify.goTo(tagError, { container: "#productForm" })
            }
        }
    },
    mounted() {
        if (this.$store.state.products.length == 0) {
            if (!this.$store.state.productDialog)
                this.$store.commit('TOGGLE_PRODUCT_DIALOG')
        }
    },
    destroyed() {

    },
    methods: {
        async getServiceSuppliers() {
            try {
                this.loadingSS = true
                this.serviceSuppliers = await this.$store.dispatch('getServiceSuppliers')
            } catch (error) {
                console.log(error);
            } finally {
                this.loadingSS = false
            }
        },
        scrollMenu() {
             setTimeout(() => {
                 document.querySelector('.combo-item').closest('.v-autocomplete__content').scroll({top:0,left:0, behavior:'smooth'})
             }, 200);

        },
        price(v) {
            return 'R$' + Number(v).toFixed(2).toString().replace('.', ',')
        },
        clipboardAction(text) {
            let testingCodeToCopy = document.querySelector('#bar-code')
            testingCodeToCopy.setAttribute('type', 'text')    // 不是 hidden 才能複製
            testingCodeToCopy.select()

            try {
                document.execCommand('copy');
                this.clipboard = true;
                setTimeout(() => this.clipboard = false, 1000);
            } catch (err) {
                alert('Função não suportada pelo seu navegador');
            }

            /* unselect the range */
            testingCodeToCopy.setAttribute('type', 'hidden')
            window.getSelection().removeAllRanges()
        },
        getComboSessionData() {
            return {
                attrs: {
                    expand: true
                }
            }
        },
        reorderSessions(evt) {
            const displayOrder = {}
            this.combo.combosession_list.forEach((v, i) => displayOrder[v] = i)
            this.combo.session_display_order = displayOrder
            this.saveCombo()
        },
        ChangeStockSwitch() {
            this.productForm.safety_margin = 0
            this.productForm.stock = 0
            this.productForm.sale_without_stock = true
        },
        ChangeCTSwitch() {
            this.productForm.costs = '0,00'
            this.productForm.taxes = 0
        },
        addingSession() {
            this.newSession = false
            this.refreshCombo(this.combo._id)
            setTimeout(() => {
                const id = this.combo.combosession_list[this.combo.combosession_list.length - 1]
                this.$vuetify.goTo(`#c${this.combo._id}s${id}`,
                    {
                        container: `#combo${this.combo._id}`
                    })
            }, 200);
        },
        async refreshCombo(id) {
            this.loading = true
            this.combo = await this.$store.dispatch("fetchCombo", id)
            this.loading = false
        },
        newCombo() {
            this.combo = {
                description: "",
                selected_products: [],
                type_id: [],
                combosession_list: [],
                enabled: true,
                combo_default_value: false
            }
            this.comboDialog = this.editComboName = true
        },
        async editCombo(id) {
            await this.refreshCombo(id)
            this.comboDialog = true
        },
        async saveCombo() {
            if (!this.combo.description.trim()) {
                this.comboErrors = ['Informe o nome do combo']
                return
            } else {
                this.comboErrors = []
            }
            try {
                const setCombo = this.combo._id == undefined
                const combo = await this.$store.dispatch("addeditCombo", this.combo)
                this.refreshCombo(combo._id)
                this.getComboes()
                if (setCombo) this.productForm.combolist_id = combo._id
            } catch (error) {
                console.log(error)
            } finally {
                this.editComboName = false
            }
        },
        async deleteCombo(id) {
            try {
                this.loading = true
                await this.$store.dispatch("removeCombo", id)
                this.getComboes()
            } catch (error) {
                console.log(error)
            } finally {
                this.loading = false
            }
            this.deleteDialog = false
        },
        deleteConfirm(options) {
            if (options.session) {
                this.delData.func = this.deleteSession
                this.delData.id = options.id
            } else {
                this.delData.func = this.deleteCombo
                this.delData.id = options.id
            }
            this.deleteDialog = true
        },
        async deleteSession(id) {
            if (!id) {
                this.newSession = false
            } else {
                try {
                    this.loading = true
                    await this.$store.dispatch("removeSession", id)
                    this.refreshCombo(this.combo._id)
                } catch (error) {
                    console.log(error)
                } finally {
                    this.loading = false
                }
            }
            this.deleteDialog = false
        },
        filter(item, queryText, itemText) {
            return this.replaceSpecialChars(itemText.toLocaleLowerCase())
                .indexOf(this.replaceSpecialChars(queryText.toLocaleLowerCase())) > -1
        },
        replaceSpecialChars(str) {
            str = str.replace(/[ÀÁÂÃ]/, "A");
            str = str.replace(/[àáâã]/, "a");
            str = str.replace(/[ÈÉÊẼ]/, "E");
            str = str.replace(/[èéêẽ]/, "e");
            str = str.replace(/[ÌÍÎĨ]/, "I");
            str = str.replace(/[ìíîĩ]/, "i");
            str = str.replace(/[ÒÓÔÕ]/, "O");
            str = str.replace(/[òóôõ]/, "o");
            str = str.replace(/[ÙÚÛŨ]/, "U");
            str = str.replace(/[ùúûũ]/, "u");
            str = str.replace(/[Ç]/, "C");
            str = str.replace(/[ç]/, "c");

            return str.replace(/[^a-z0-9]/gi, '');
        },
        async setForm() {
            if (this.product) {
                this.productForm = Object.assign({}, this.product)
                if (this.productForm.safety_margin != 0 ||
                    this.productForm.stock != 0 ||
                    this.productForm.sale_without_stock != true) {
                    this.stockFields = true
                } else {
                    this.stockFields = false
                }
                if ((this.productForm.costs && this.productForm.costs != 0) ||
                    (this.productForm.taxes && this.productForm.taxes != 0)) {
                    this.CTFields = true
                } else {
                    this.CTFields = false
                }
                const priceField = Math.round(this.product[(this.product.unit == 'G') ?
                    'original_price' : 'price'] * 100)
                this.$refs.price.$el.getElementsByTagName('input')[0].value = priceField
                if (this.product.discount) {
                    this.$refs.regular_price.$el.getElementsByTagName('input')[0].value = Math.round(this.product.regular_price * 100)
                }
                if (this.product.costs) {
                    setTimeout(() => {
                        this.$refs.costs.$el.getElementsByTagName('input')[0].value = Math.round(this.product.costs * 100)
                    }, 200);
                }
                if (this.product.combolist_id) {
                    this.refreshCombo(this.product.combolist_id)
                } else {
                    this.combo = {
                        description: this.product.productname,
                        combo_default_value: false,
                        combosession_list_data: {},
                        enabled: true,
                        selected_products: [],
                        type_id: [],
                        combosession_list: []
                    }
                }
            } else {
                if (this.typeSelected && !this.typeSelected.highlight) {
                    this.productForm.type_id = this.$store.state.typeSelected.type_id
                }
                this.productForm.code = await this.$store.dispatch('generateCode')
                this.combo = {
                    description: this.productForm.productname,
                    selected_products: [],
                    type_id: [],
                    combosession_list: [],
                    combosession_list_data: {}
                }
            }
            if (this.productForm.type_id != '') {
                this.getSubtypes()
            }
            this.getComboes()
        },
        resetProduct() {
            this.productForm = {
                productname: '',
                productname_display: '',
                price: '0,00',
                original_price: '0,00',
                regular_price: '0,00',
                discount: false,
                photo: '',
                description: '',
                details: '',
                code: '',
                bar_code: '',
                type_id: '',
                subtype_id: '',
                combolist_id: '',
                multiple: 1,
                unit: "UN",
                product_yield: 1000,
                max_quantity: 0,
                safety_margin: 0,
                first_purchase_only: false,
                promotional_product: false,
                hide_on_app: false,
                stock: 0,
                sale_without_stock: true,
                active: true,
                highlight: false,
                pending_print: false,
                keywords: [],
                costs: '0,00',
                taxes: 0,
                costs_recipient_restaurant_id: '',
            }
            this.stockFields = false
            this.CTFields = false
            this.$refs.price.$el.getElementsByTagName('input')[0].value = 0.00
            this.$refs.regular_price.$el.getElementsByTagName('input')[0].value = 0.00
            if (this.$refs.costs) {
                this.$refs.costs.$el.getElementsByTagName('input')[0].value = 0.00
            }
        },
        exit() {
            this.$vuetify.goTo(0,
                {
                    container: "#productForm",
                    offset: 0
                })
            this.$validator.reset()
            this.resetProduct()
            this.combo = {
                description: "",
                selected_products: [],
                type_id: [],
                combosession_list: []
            },
                this.error = null
            setTimeout(() => {
                this.$emit('close')
            }, 200);
        },
        createType() {
            this.$store.commit('TOGGLE_TYPE_DIALOG')
        },
        editType() {
            if (this.productForm.type_id == '') return
            const type = this.menu.find(v => v._id == this.productForm.type_id)
            if (!type) return
            this.$store.commit('FETCH_TYPE', type)
            this.$store.commit('TOGGLE_TYPE_DIALOG')
        },
        async getSubtypes() {
            if (this.productForm.type_id != '') {
                this.stLoading = true
                const res = await this.$store.dispatch('getSubtypes', this.productForm.type_id)
                if (res.data.ok) {
                    this.subtypes = res.data.data
                } else {
                    this.subtypes = [{ _id: '', name: 'Nenhum' }]
                }
                this.stLoading = false
            } else {
                this.subtypes = [{ _id: '', name: 'Nenhum' }]
            }
        },
        async getComboes() {
            try {
                this.comboes = await this.$store.dispatch('fetchCombo')
            } catch (error) {
                console.log(error)
            }
        },
        async onSubmit() {
            if (this.cropping) {
                this.error = "Confirme a imagem para continuar"
                return
            } else {
                this.error = ''
            }
            let valid = await this.$validator.validateAll()
            if (valid) {
                this.loading = true
                const data = Object.assign({}, this.productForm)
                if (this.product) {
                    if (data.photo && data.photo.startsWith("/static"))
                        delete data.photo
                    if (!data.combolist_id) {
                        data.combolist_id = ""
                    }
                    data.product_id = data._id
                    this.$store.dispatch('updateProduct', data).then(res => {
                        this.$validator.reset()
                        this.resetProduct()
                        setTimeout(async () => {
                            this.$store.commit("TOGGLE_PRODUCT_DIALOG")
                        }, 300);
                        this.loading = false
                    }).catch(err => {
                        this.error = err
                        this.loading = false
                    })
                } else {
                    if (!data.combolist_id) {
                        delete data.combolist_id
                    }
                    this.$store.dispatch('createProduct', data).then(async res => {
                        this.$validator.reset()
                        this.resetProduct()
                        this.productForm.type_id = res.type_id
                        setTimeout(async () => {
                            await this.$store.commit("TOGGLE_PRODUCT_DIALOG")
                            this.$store.commit("TOGGLE_PRODUCT_DIALOG")
                        }, 300);
                        this.loading = false
                    }).catch(err => {
                        this.error = err
                        this.loading = false
                    })
                }
            }
        }
    }
}
</script>
 